'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatSingleOdds = exports.formatOdds = exports.oddsFormats = undefined;

var _constants = require('@sb/odds-format-common/dist/main/constants');

var _formatter = require('./formatter');

exports.oddsFormats = _constants.ODDS_FORMATS;
exports.formatOdds = _formatter.formatOdds;
exports.formatSingleOdds = _formatter.formatSingleOdds;